import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {GwanboData} from './GwanboData';
import useTocsBookId from './useTocsBookId';
import ReactModal from "react-modal";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {selectedPerson} from "../../../recoils/recoil";

ReactModal.setAppElement('#root'); // 모달을 렌더링할 DOM 노드 설정

/**
 * 아카이브 > 조선총독부관보 서임급사령 중 교원부분
 * @returns {JSX.Element}
 * @constructor
 */
const GwanboPersonnel = (props) => {
    // getter
    const selectedPersonList = useRecoilValue(selectedPerson);
    // setter
    const setSelectedPersonList = useSetRecoilState(selectedPerson);

    const navigate = useNavigate();
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [bookId, setBookId] = useState(null);
    // const {tocsData, totalCnt} = useTocsBookId(bookId);
    const {tocsData} = useTocsBookId(bookId);
    const [listTitle, setListTitle] = useState('');
    const [showModal1, setShowModal1] = useState(false);

    // 년, 월, 일을 기준으로 정렬
    GwanboData.sort((a, b) => {
        if (a.publish_year !== b.publish_year) {
            return a.publish_year - b.publish_year; // 년도 기준 정렬
        } else if (a.publish_month !== b.publish_month) {
            return a.publish_month - b.publish_month; // 월 기준 정렬
        } else {
            return a.publish_day - b.publish_day; // 일 기준 정렬
        }
    });

    // 중복되지 않은 년도 리스트
    const uniqueYears = [...new Set(GwanboData.map(item => item.publish_year))];

    // 선택된 년도의 중복되지 않은 월 리스트
    const uniqueMonths = selectedYear
        ? [...new Set(GwanboData.filter(item => item.publish_year === selectedYear).map(item => item.publish_month))]
        : [];

    // 선택된 년도와 월에 해당하는 데이터 필터링
    const filteredData = GwanboData.filter(
        item => item.publish_year === selectedYear && item.publish_month === selectedMonth
    );

    const onSelectedYear = (year) => {
        onSelectedFirstData(year, null);
        // setSelectedYear(year);
        // setSelectedMonth(null);
        // setBookId(null);

    }

    const onSelectedMonth = (month) => {
        onSelectedFirstData(selectedYear, month);
        // setSelectedMonth(month);
        // setBookId(null);
    }

    const onSelectedBookId = (item) => {
        setBookId(item.book_id);
        setListTitle(item.book_title + ' ' + item.numeration + ' ' + item.publish_date);
    }


    // 모달창으로 인해 사용하지 않을 수 있음.
    const onSelectedFirstData = (year, month) => {
        if (year && !month) {
            // 년도만 클릭한 경우: 해당 년도의 첫 번째 월과 첫 번째 book_id 선택
            const firstMonth = GwanboData.find(item => item.publish_year === year)?.publish_month || null;
            // const firstBookId = GwanboData.find(item => item.publish_year === year && item.publish_month === firstMonth)?.book_id || null;

            setSelectedYear(year);
            setSelectedMonth(firstMonth);
            // setBookId(firstBookId);
        } else {
            // 년도와 월이 모두 선택된 경우: 해당 월의 첫 번째 book_id 선택
            // const firstBookId = GwanboData.find(item => item.publish_year === year && item.publish_month === month)?.book_id || null;

            setSelectedYear(year);
            setSelectedMonth(month);
            // setBookId(firstBookId);
        }
    };

    const handlePersonClick = (order) => {
        let idList = [];
        setSelectedPersonList([...selectedPersonList, {
            id: order.person_id,
            name:order.personname,
            nameKo:order.personname
        }]);

        idList.push(order.person_id)

        // 배열에 넣어서 personId 보내기
        navigate(`/person/${idList}`);
    }

    const handleOpenModal1 = () => {
        setShowModal1(true);
    };

    const handleCloseModal1 = () => {
        setShowModal1(false);
        setBookId(null);
    };

    useEffect(() => {
        if(tocsData.length === 0) return;
        if(tocsData.length > 0) {
            handleOpenModal1();
        }
    }, [tocsData]);

    useEffect(() => {
        // setPosts(sortedGwanboData);
        onSelectedFirstData(1942, 1);
        // onSelectedYear(1911);
        // onSelectedMonth(5);
        // onSelectedBookId(127);
    }, []);

    return (
        <>
            <main id="contents">
                <div className="sub-content">
                    <div className="archive-wrap">
                        <div className="cont-top">
                            <div className="w-set">
                                <div className="title-wrap">
                                    <h2 className="title batang">조선총독부관보 서임급사령 중 <br className="hide-pc"/>교원부분</h2>
                                    <p className="text">조선총독부관보의 서임급사령에서 교원의 임명, 해직 등의 정보를 알 수 있습니다.</p>
                                </div>
                            </div>
                        </div>
                        <div className="cont-btm">
                            <div className="archive-text-box">
                                <div className="w-set">
                                    <div className="text-wrap">
                                        <p><strong>조선총독부관보</strong></p>
                                        <p className="text">일제강점기 누가, 언제, 어느 학교에 부임했을 까요? 조선총독부는 조선에 근무하는 공직자들에 대한 임명, 이동,
                                            승진, 증봉, 휴직, 복직, 징계 등 인사 사항을 매일 같이 『관보』 ‘서임급사령’란을 통해 발표했습니다. 이를 보면 관공립학교
                                            교원에 인사 발령을 확인할 수 있습니다. 센터는 『관보』에 기재된 교원에 대한 모든 발령 정보 중 일부를
                                            『조선총독부관보 서임급사령』으로 정리하여 제공합니다. 우리는 이를 통해 일제 강점기 관공립 학교 교원의 인사 발령 내용
                                            과 이동 날짜를 파악할 수 있습니다. 센터는 향후 장기적으로 교원관련 명령을 구축할 예정입니다.</p>
                                    </div>
                                    <div className="img-wrap">
                                        <div className="archive-slides">
                                            <ul className="slides-wrapper">
                                                <li><div className="imgbox"><img src="/images/archive/gwanboPersonnel_main.gif" alt="조선총독부관보 서임급사령 중 교원부분_1939년 11월 13일 정규호 3845호"/></div>
                                                    <p className="caption">조선총독부관보 서임급사령 중 교원부분_1939년 11월 13일 정규호 3845호</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="list-wrap">
                                <div className="w-set">
                                    <div className="list-btm">
                                        <div className="table-wrap">
                                            <div className="year-wrap">
                                                <div className="year-slides">
                                                    <ul className="slides-wrapper">
                                                        {[...Array(1943 - 1942 + 1)].map((_, index) => {
                                                            const year = 1942 + index; // 1911부터 1949까지의 모든 년도 생성
                                                            const isYearAvailable = uniqueYears.includes(year); // 해당 년도가 데이터에 존재하는지 확인

                                                            return (
                                                                <li
                                                                    className={selectedYear === year ? 'on' : ''}
                                                                    key={year}
                                                                    onClick={() => isYearAvailable && onSelectedYear(year)} // 데이터가 있는 경우에만 클릭 이벤트 활성화
                                                                    disabled={!isYearAvailable} // 데이터가 없는 경우 버튼 비활성화
                                                                    style={{
                                                                        cursor: isYearAvailable ? 'pointer' : 'not-allowed', // 비활성화 시 마우스 커서 변경
                                                                    }}
                                                                >
                                                                    {year}
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="month-wrap">
                                                <div className="month-list">
                                                    {selectedYear && (
                                                        <>
                                                            {[...Array(12)].map((_, index) => {
                                                                const month = index + 1; // 1월부터 12월까지 생성
                                                                const isMonthAvailable = uniqueMonths.includes(month); // 해당 월이 데이터에 존재하는지 확인

                                                                return (
                                                                    <button
                                                                        className={selectedMonth === month ? 'month on' : 'month'}
                                                                        key={selectedYear + '_' + month}
                                                                        onClick={() => isMonthAvailable && onSelectedMonth(month)} // 데이터가 있는 경우에만 클릭 이벤트 활성화
                                                                        disabled={!isMonthAvailable} // 데이터가 없는 경우 버튼 비활성화
                                                                        style={{
                                                                            cursor: isMonthAvailable ? 'pointer' : 'not-allowed', // 비활성화 시 커서 변경
                                                                        }}
                                                                    >
                                                                        {month}월
                                                                    </button>
                                                                );
                                                            })}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="scroll-table">
                                                {selectedMonth && (
                                                    filteredData.map((item, index) => (
                                                        <div className="list-row" key={item.book_id} onClick={() => onSelectedBookId(item)} style={{cursor: 'pointer'}}>
                                                            <div className="row-link">
                                                                <div className="title bold">{item.book_title}</div>
                                                                <div className="number">{item.numeration}</div>
                                                                <div className="date">{item.publish_date}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ReactModal
                isOpen={showModal1}
                onRequestClose={handleCloseModal1}
                contentLabel="First Modal"
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 1000,
                    },
                    content: {
                        inset:"unset",
                        padding:0,
                        border:"none",
                        borderRadius:0,
                        background: "transparent",
                        width:"auto",
                        height:"auto"
                    }
                }}
            >
                <div
                    className="wbz-popup-cont is-template"
                    id="doboViewPopup"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div className="popup-header">
                        <b className="popup-title">{listTitle}</b>
                        <button type="button" className="popup-close" onClick={handleCloseModal1}>닫기</button>
                    </div>
                    <div className="popup-cont">
                        {bookId && (
                            <div className="list-table type-row">
                                {tocsData
                                    .filter((toc) => toc.orders.length > 0)
                                    .map((toc, index) => (
                                    <div className="list-wrap" key={toc.toc_id}>
                                        <div className="list-title">{toc.toc_title.includes("/") ? toc.toc_title.split("/")[1] : toc.toc_title}</div>
                                            <ul className="list-cont">
                                            {toc.orders.map((order, index) => (
                                                <li className="list-item" key={`${order.psnorders_id}_${index}`}>
                                                    {order.status_text && order.status_text + ' '}
                                                    <button className="search-text" onClick={() => handlePersonClick(order)}>{order.personname}</button>
                                                    {' '}{order.order_text}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </ReactModal>
        </>
    )
        ;
}

export default GwanboPersonnel;